import { rulesTabContent } from '../constants/rules.constant';
import { RuleMessage } from './rule-message';

export const RuleNotFound = (): JSX.Element => (
  <RuleMessage
    title={rulesTabContent.ruleNotFound.title}
    body={rulesTabContent.ruleNotFound.body}
  />
);
